<ng-template #template let-anchor>
    <span>{{ anchor.nativeElement.innerText }}</span>
</ng-template>

<div class="cg3-multiselect">
    <div class="cg3-host-form-field">
        <div class="cg3-form-field">
            @if (label) {
                <div class="cg3-host-form-field-header">
                    <div class="cg3-form-field-header cg3-multiselect-field-header">
                        <div class="cg3-host-form-field-label">
                            <form-field-label-pds3>
                                <span>{{ label | wkTranslate }}</span>
                            </form-field-label-pds3>
                        </div>
                    </div>
                </div>
            }

            <div class="cg3-host-form-field-body">
                <div class="cg3-form-field-body cg3-multiselect-body-container cg3-form-field-body-{{ size }}">
                    <div
                        class="cg3-form-field-body-container"
                        kendoTooltip
                        #tt="kendoTooltip"
                        [tooltipTemplate]="template"
                        filter="li.k-list-item"
                        showOn="none"
                        (mouseover)="onMouseOver($event)"
                        (mouseleave)="onMouseLeave($event)"
                        [tooltipClass]="'kendo-multiselect-wrapper-tooltip'"
                    >
                        <kendo-multiselect
                            [data]="filteredData"
                            [value]="value"
                            (valueChange)="handleValueChange($event)"
                            [valuePrimitive]="filterChange.observed || !valuePrimitive ? false : true"
                            [textField]="textField"
                            [valueField]="valueField"
                            [placeholder]="placeholder"
                            [popupSettings]="{ appendTo: 'component', popupClass: 'multiselect-wrapper-popup', animate: false }"
                            fillMode="none"
                            rounded="none"
                            [size]="size"
                            [virtual]="
                                virtual
                                    ? {
                                          itemHeight: size === 'large' ? 44 : 32,
                                          pageSize: 30,
                                      }
                                    : false
                            "
                            [listHeight]="size === 'large' ? 282 : 210"
                            [adaptiveMode]="virtual ? 'none' : 'auto'"
                            [filterable]="true"
                            (filterChange)="onFilterChange($event)"
                            [disabled]="disabled"
                            [tabindex]="disabled ? -1 : 0"
                            kendoMultiSelectSummaryTag
                            [autoClose]="false"
                            [checkboxes]="true"
                            class="wk-multiselect"
                            [inputAttributes]="{ class: 'cg3-multiselect-body' }"
                            closeOnAncestorScroll
                            [itemDisabled]="onItemDisabled"
                        >
                            @if (clearTitleText) {
                                <kendo-multiselect-messages [clearTitle]="clearTitleText"> </kendo-multiselect-messages>
                            }

                            <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                <div class="multiselect-wrapper-item">
                                    {{ dataItem | nestedValue: textField | wkTranslate }}
                                </div>
                            </ng-template>

                            <ng-template kendoMultiSelectGroupTagTemplate let-dataItems>
                                <span class="text-resizing">
                                    {{ dataItems.length }}
                                </span>
                            </ng-template>

                            @if (noDataText) {
                                <ng-template kendoMultiSelectNoDataTemplate>
                                    <span class="text-resizing">
                                        {{ noDataText }}
                                    </span>
                                </ng-template>
                            }

                            <ng-template kendoSuffixTemplate>
                                <button kendoButton fillMode="none" (click)="toggleDropdown()" tabindex="-1"></button>
                            </ng-template>
                        </kendo-multiselect>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
